import { extendTailwindMerge } from "tailwind-merge";

export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      /**
       * Custom utility classes defined in theme.css @theme blocks.
       * Keys can be found in the default config: https://github.com/dcastil/tailwind-merge/blob/v2.2.0/src/lib/default-config.ts#L123
       */
      "font-size": [
        "text-xxxs",
        "text-xxs",
        "text-xs",
        "text-sm",
        "text-md",
        "text-title",
        "text-button-label",
        "text-code-block",
        "text-node-xxxs",
        "text-node-xxs",
        "text-node-xs",
        "text-node-sm",
        "text-node-size-10",
        "text-node-size-11",
        "text-node-size-12",
        "text-node-size-13",
        "text-node-size-14",
        "text-node-size-15",
        "text-node-size-16",
        "text-node-size-17",
        "text-node-size-18",
        "text-node-size-20",
        "text-node-size-24",
        "text-node-size-32",
        "text-node-size-34",
        "text-node-size-36",
        "text-node-size-40",
        "text-node-size-48",
        "text-node-size-62",
        "text-size-10",
        "text-size-11",
        "text-size-12",
        "text-size-13",
        "text-size-14",
        "text-size-15",
        "text-size-16",
        "text-size-17",
        "text-size-18",
        "text-size-20",
        "text-size-24",
        "text-size-30",
        "text-size-32",
        "text-size-34",
        "text-size-36",
        "text-size-40",
        "text-size-46",
        "text-size-48",
        "text-size-62",
      ],
      rounded: [
        "rounded-3",
        "rounded-4",
        "rounded-5",
        "rounded-6",
        "rounded-7",
        "rounded-8",
        "rounded-10",
        "rounded-12",
        "rounded-14",
      ],
      w: [
        "w-0.3",
        "w-4.5",
        "w-5.5",
        "w-6.5",
        "w-7.5",
        "w-9.5",
        "w-10.5",
        "w-sidebar-width",
        "w-content-width",
        "w-content-wrapper-width",
        "w-line-number-width",
      ],
      "min-w": [
        "min-w-4.5",
        "min-w-5.5",
        "min-w-6.5",
        "min-w-9.5",
        "min-w-sidebar-width",
        "min-w-content-width",
        "min-w-content-wrapper-width",
        "min-w-line-number-width",
      ],
      shadow: [
        "shadow-block",
        "shadow-block-selected",
        "shadow-block-inverted",
        "shadow-input",
        "shadow-input-invalid",
        "shadow-input-inverted",
        "shadow-chat",
        "shadow-color-item",
        "shadow-border",
        "shadow-node-outline",
        "shadow-node-hover",
        "shadow-node-outline-border",
        "shadow-node-outline-border-hover",
        "shadow-node-outline-border-hover-inverted",
      ],
    },
  },
});
